module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/PayrollHistory.html -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2 class="payroll-history-title">\n            ';
 if (!collection) { 
__p+='\n                Loading payrolls\n            ';
 } else if (collection && collection.length <= 0) { 
__p+='\n                No payrolls available\n            ';
 } else { 
__p+='\n                Viewing '+
((__t=( collection.length ))==null?'':_.escape(__t))+
' Payrolls:\n\n                ';
 if (collection.getSavedCount()) { 
__p+='\n                    <div class="label label-default">\n                        '+
((__t=( collection.getSavedCount() ))==null?'':_.escape(__t))+
' Saved\n                    </div>\n                ';
 } 
__p+='\n                ';
 if (collection.getSubmittedCount()) { 
__p+='\n                    <div class="label label-warning">\n                        '+
((__t=( collection.getSubmittedCount() ))==null?'':_.escape(__t))+
' Submitted\n                    </div>\n                ';
 } 
__p+='\n                ';
 if (collection.getCompletedCount()) { 
__p+='\n                    <div class="label label-primary">\n                        '+
((__t=( collection.getCompletedCount() ))==null?'':_.escape(__t))+
' Completed\n                    </div>\n                ';
 } 
__p+='\n            ';
 } 
__p+='\n        </h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n<div class="row">\n<div class="col-md-12 col-lg-12">\n<div class="ibox float-e-margins">\n    <div class="ibox-title">\n        <h5>Payroll History</h5>\n    </div>\n\n    <div class="ibox-content">\n        <div class="row payroll-history-items">\n            <div class="col-xs-12">\n                '+
((__t=( require('commons/templates/Spinner.html')() ))==null?'':__t)+
'\n\n                <div class="empty-list text-center">\n                    <h1>\n                        You currently have no saved, submitted or\n                        completed payrolls.\n                    </h1>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n</div>\n</div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/PayrollHistory.html
// module id = 761
// module chunks = 1